import { isValidLink } from "@/lib/config/lib/helper"
import { ServiceSidebarNavItemProps } from "@/types/types"
import { ensureProtocol } from "@/utils/ensure-protocol-helper"
import Link from "next/link"
import type React from "react"
import { twMerge } from "tailwind-merge"

export const ServiceSidebarNavItem: React.FC<ServiceSidebarNavItemProps> = ({
  categoryName,
  link,
  isActive,
  onClick,
  contentType,
}) => {
  const hasValidLink = isValidLink(link)

  const baseClassName = twMerge(
    "sm:flex-none sm:block text-left sm:text-sm px-4 text-xs leading-[2.5625rem] sm:leading-[2.5625rem] font-normal sm:pl-[1.3125rem] transition-colors whitespace-nowrap cursor-pointer",
    isActive ? "sm:bg-[#F7F7F7] sm:font-semibold sm:text-[#333333] text-white bg-[#18AF4E]" : "text-[#333333]",
  )

  const handleClick = (e: React.MouseEvent) => {
    switch (contentType) {
      case "link":
        if (hasValidLink) {
          return
        }
        break
      default:
        onClick()
        if (!hasValidLink) {
          e.preventDefault()
          e.stopPropagation()
        }
        break
    }
  }

  switch (contentType) {
    case "link":
      if (hasValidLink && link) {
        return (
          <Link href={ensureProtocol(link)} className={baseClassName}>
            {categoryName}
          </Link>
        )
      }
      break

    case "ckeditor":
    case "career":
    case "faqs":
    default:
      if (hasValidLink && link) {
        return (
          <Link href={ensureProtocol(link)} onClick={handleClick} className={baseClassName}>
            {categoryName}
          </Link>
        )
      }
      break
  }

  return (
    <button type="button" onClick={handleClick} className={baseClassName}>
      {categoryName}
    </button>
  )
}
